import type { TraceCandidate } from "./types";

export const candidateEvidence = (candidate: TraceCandidate) => {
  const conditions =
    candidate.expected_conditions ?? candidate.recorded_conditions;
  const preview = candidate.preview_rules.length > 0;
  const rules = preview
    ? candidate.preview_rules
    : conditions.filter((condition) => condition.type === "rule");
  const modelConditions = conditions.filter(
    (condition) => condition.type === "ask",
  );
  const fallbackEligible =
    candidate.preview_fallback_eligible ?? candidate.fallback_eligible;
  const fallbackNote =
    candidate.preview_selection_note ?? candidate.selection_note;
  return {
    rules,
    modelConditions,
    checks: [...rules, ...modelConditions],
    partial: candidate.expected_conditions === null,
    preview,
    fallbackEligible,
    fallbackNote,
    hasFallbackGate: fallbackEligible != null || fallbackNote != null,
  };
};

export const candidateVerdict = (candidate: TraceCandidate): string => {
  const { fallbackEligible, fallbackNote } = candidateEvidence(candidate);
  if (candidate.evaluation_status !== "chosen" && fallbackEligible === false)
    return candidate.preview_source
      ? "Current policy: fallback not eligible"
      : "Fallback not eligible";
  if (
    candidate.evaluation_status !== "chosen" &&
    fallbackNote != null &&
    fallbackEligible == null
  )
    return "Fallback eligibility unknown";
  switch (candidate.evaluation_status) {
    case "chosen":
      return "Selected";
    case "failed":
      return "Did not qualify";
    case "undecided":
      return "Undecided";
    case "held":
      return "Conditions met · not selected";
    case "unknown":
      return "Unknown";
  }
};
